import React, { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { InputWrapper, InputError, TextInputExtended } from 'src/components';
import { useOnlyLettersControl } from './use-only-letters-control';
import { useDispatch, useSelector } from 'react-redux';
import { IdPerson, OneFormState } from 'src/types';
import { store } from 'src/feature-app';

interface NombreProps {
  idPerson?: IdPerson;
  paddingTop?: string;
  paddingBottom?: string;
}

export function Nombre(props: NombreProps) {
  const { idPerson } = props;
  const dispatch = useDispatch();
  const { register } = useFormContext();
  const [inputValue, setInputValue] = useState('');
  const [pristine, setPristine] = useState(true);
  const { error, regExp } = useOnlyLettersControl(pristine, inputValue);
  const { formInfo } = useSelector((state: OneFormState) => state);

  const handleChange = (e: any) => {
    if (!error) {
      dispatch({ type: 'UPDATE_FIELDS', payload: { ['name']: e.target.value } });
    }

    setInputValue(e.target.value);
    setPristine(false);
  };

  return (
    <InputWrapper className="nombre-input-wrapper" notALayer={formInfo.notALayer} paddingTop={props.paddingTop} paddingBottom={props.paddingBottom}>
      <TextInputExtended
        name="name"
        label="Nombre"
        isFloating
        innerRef={register({
          required: {
            value: true,
            message: 'Requerido',
          },
          pattern: {
            value: regExp,
            message: 'Solo se aceptan letras',
          },
        })}
        onChange={(e) => handleChange(e)}
        required
      />
      {error && <InputError className="input-error">Solo se aceptan letras</InputError>}
    </InputWrapper>
  );
}
